import React from 'react';

import { mosaiqStyled } from '../../lib';

import { AvatarProps } from './types';

import { AvatarContainer } from './Avatar.styles';

const Avatar = mosaiqStyled<AvatarProps, HTMLDivElement>(({ children, innerRef, ...props }) => {
  return (
    <AvatarContainer ref={innerRef} {...props}>
      {children}
    </AvatarContainer>
  );
});

Avatar.displayName = 'Avatar';

export default Avatar;
